import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router';
import { ErrorBoundary } from '@sentry/react';
import { CriticalErrorView } from 'components/views/CriticalErrorView';
import { AppContainer } from './styles';
import { MainView } from 'components/views/MainView';
import { Header } from '../Header';
import { Skeleton } from '../Skeleton';
import { ToastBar } from 'stateful-ui/src/components/ToastBar';

export const AppRouter = () => {
  return (
    <Router>
      <AppContainer>
        <Header />
        <ErrorBoundary fallback={CriticalErrorView}>
          <Suspense fallback={<Skeleton />}>
            <Routes>
              <Route path="/" element={<MainView />} />
            </Routes>
          </Suspense>
          <ToastBar />
        </ErrorBoundary>
      </AppContainer>
    </Router>
  );
};
